import { useMemo } from 'react'
import { Box, SimpleGrid, Text } from '@chakra-ui/react'
import { BookTitle } from '@!/Store/Common/components/ListItem'
import { RankingCrown } from '@!/Store/Home/components'

const RankingTitleList = ({ rankingTitles, currentTab }) => {
  const genreLabels = useMemo(
    () => ({
      boy: '少年',
      man: '青年',
      girl: '少女',
      lady: '女性',
      tl: 'TL',
      bl: 'BL',
    }),
    [],
  )

  return (
    <SimpleGrid columns={{ base: 3, md: 7 }} spacing={4} py={3} boxSizing="border-box">
      {rankingTitles.map(({ title_name, title_id, image_url, genre_name }, index) => (
        <Box key={title_id}>
          <BookTitle title={title_name} titleId={title_id} imageUrl={image_url} w="100px" />
          <RankingCrown ranking={index + 1} />
          {/* 総合/メディア化/オリジナルのタブが選択されてる場合のみジャンル名を表示 */}
          {['total', 'media', 'amazia'].includes(currentTab.name) && (
            <Text fontSize="3xs" color="label.tertiary" textAlign="left" w="100%">
              {genreLabels[genre_name] || ''}
            </Text>
          )}
        </Box>
      ))}
    </SimpleGrid>
  )
}

export default RankingTitleList
